import createSvgIcon from '../Utils/CreateSvgIcon';

export const Minus = createSvgIcon(<path d="M21 13L3 13V11L21 11L21 13Z" />, 'Minus');
